import { toCamelCaseProperties } from '@/utils/fn';

export default class UmbracoBase {
	constructor(args) {
		// Properties as camelcase
		args = toCamelCaseProperties(args) || {};

		// Targeting
		let targeting = [];
		(args.targeting || []).forEach(function(item) {
			item.properties.forEach(property => {
				if (property.propertyTypeAlias == 'fixitId') {
					targeting.push(property.content);
				}
			});
		});
		this.targeting = targeting;

		// Visibility
		this.hiddenMobile = args.hiddenMobile;
		this.hiddenTablet = args.hiddenTablet;
		this.hiddenDesktop = args.hiddenDesktop;

		this.classObject = {
			'd-xs-none': this.hiddenMobile,
			'd-sm-none': this.hiddenTablet,
			'd-md-none': this.hiddenTablet,
			'd-lg-none': this.hiddenDesktop,
			'd-xl-none': this.hiddenDesktop
		};
	}
}
